import React, { useState } from 'react';
import '../Css/LoginForm.css';
import { useNavigate } from 'react-router-dom';
import { MDBBtn, MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput } from 'mdb-react-ui-kit';
import { CircularProgress } from '@mui/material';

function LoginForm() {
    const [name, setName] = useState('');
    const [course, setCourse] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');

        const loginData = { name, course, email };

        try {
            const response = await fetch(`/api/login/loginUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(loginData)
            });
            setIsLoading(true);

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'An error occurred. Please try again.');
            }

            const data = await response.json();

            if (data.success) {
                sessionStorage.setItem("SName", data.Sname);
                sessionStorage.setItem("SEmail", data.Semail);
                navigate('/testGenerated');
            } else {
                setMessage(data.message || 'Login failed. Please try again.');
            }
        } catch (error) {
            setMessage(error.message || 'An error occurred. Please try again.');
        }
    };

    return (
        <MDBContainer fluid className='pom4 background-radial-gradient overflow-hidden' style={{ userSelect: "none", WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none" }} >
            <MDBRow>
                <div>
                    <img src="/bntLogo.png" alt="Logo" className='logo' />
                </div>
                <MDBCol md='6' className='text-center text-md-start d-flex flex-column justify-content-center TopHere'>
                    <div>
                        <h1 className="my-5 display-3 fw-bold ls-tight px-3" style={{ color: 'hsl(218, 81%, 95%)' }}>
                            Welcome to the Test Portal<br />
                            <span style={{ color: 'hsl(218, 81%, 75%)' }}>Sign in to start your test</span>
                        </h1>
                        <p className='px-3' style={{ color: 'hsl(218, 81%, 85%)', marginTop: '-20px' }}>
                            Please enter your details to log in. If you're authorized, you'll be redirected to the test page.
                        </p>
                    </div>
                </MDBCol>

                <MDBCol md='12' className='poise'>
                    <div className='shapesArea'>
                        <div className='instructions'>
                            <h2>Please read the instructions carefully :</h2>
                            <ul>
                                <li>Please <b className='bold'>do not refresh the test</b> page.</li>
                                <li>Use your <b className='bold'>Email ID that is registered</b> with the college.</li>
                                <li>You can only <b className='bold'>login once</b>, so be careful.</li>
                                <li>There will be a set of <b className='bold'>45 questions</b> for this test, all of them are <b className='bold'>compulsory</b>.</li>
                                <li>You will get only <b className='bold'>45 minutes</b> to solve the test, so use your time wisely.</li>
                                <li>The timer will start when you fill all your details and click on the <b className='bold'>'Login & Generate Test'</b> button.</li>
                            </ul>
                        </div>
                    </div>
                    <div className='formArea'>
                        <MDBCard className='bg-glass'>
                            <MDBCardBody className='pom5'>
                                <form onSubmit={handleSubmit} autoComplete="off">
                                    <MDBInput className='dataHere' wrapperClass='mb-4' placeholder='Name' id='form1' type='text' value={name} onChange={(e) => setName(e.target.value)} required />
                                    <MDBInput className='dataHere' wrapperClass='mb-4' placeholder='Course' id='form2' type='text' value={course} onChange={(e) => setCourse(e.target.value)} required />
                                    <MDBInput className='dataHere' wrapperClass='mb-4' placeholder='Email' id='form3' type='email' value={email} onChange={(e) => setEmail(e.target.value)} required />
                                    <MDBBtn type='submit' className='submitButtonHere' style={{ width: '87%' }} disabled={isLoading}>
                                        {isLoading ? <CircularProgress size={20} color="inherit" /> : "Login & Generate Test"}
                                    </MDBBtn>
                                </form>
                                {message && (
                                    <div className="text-center bold">
                                        <p><b>{message}</b></p>
                                    </div>
                                )}
                            </MDBCardBody>
                        </MDBCard>
                    </div>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
}

export default LoginForm;